import { render, staticRenderFns } from "./prescripteurs.html?vue&type=template&id=05b909e0&scoped=true&external"
import script from "./prescripteurs.js?vue&type=script&lang=js&external"
export * from "./prescripteurs.js?vue&type=script&lang=js&external"
import style0 from "./prescripteurs.scss?vue&type=style&index=0&id=05b909e0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b909e0",
  null
  
)

export default component.exports